import React from "react";
import SidebarPage from "../pages/sideBar/SideBarPage";

/**
 * Çocuk bileşeni, eğer giriş yapan kullanıcı admin ise Sidebar ile birlikte gösterir.
 * Admin rolü localStorage'daki "userRole" anahtarından okunur.
 */
const SidebarConditional = ({ children }) => {
  const role = localStorage.getItem("userRole");
  const isAdmin = role === "admin";

  if (isAdmin) {
    return <SidebarPage>{children}</SidebarPage>;
  }
  return <>{children}</>;
};

export default SidebarConditional; 